import React from "react";
import { TransactionRule } from "../../common/types/transactionRule";
import { RuleCategoryAction } from "./RuleAction/RuleCategoryAction";
import { RuleEntityAction } from "./RuleAction/RuleEntityAction";
import { RuleAccountAction } from "./RuleAction/RuleAccountAction";

interface Props {
    rule: Pick<
        TransactionRule,
        | "categoryId"
        | "category"
        | "entityId"
        | "entity"
        | "accountId"
        | "accountNumber"
        | "conditions"
    >;
}

export const TransactionRuleActions: React.FC<Props> = ({ rule }) => (
    <div className="d-flex flex-column gap-1">
        <RuleCategoryAction rule={rule} /> <RuleEntityAction rule={rule} />{" "}
        <RuleAccountAction rule={rule} />
    </div>
);
